// extracted by mini-css-extract-plugin
export default {"icon":"SortingWithText_icon__dye8G"};